import { Input } from '@headlessui/react';
import type { FormFieldDto } from '../../form.types';

interface FormFieldRangeProps {
    field: FormFieldDto;
}

export function FormFieldRange({ field }: FormFieldRangeProps) {
    const min = field.validation?.find((v) => v.type === 'min')?.value;
    const max = field.validation?.find((v) => v.type === 'max')?.value;
    const step = field.validation?.find((v) => v.type === 'step')?.value;

    return (
        <Input
            name={field.name}
            required={field.required}
            defaultValue={field.options?.defaultValue}
            type="range"
            className="form-input"
            min={min}
            max={max}
            step={step}
        />
    );
}
